import { connect } from 'react-redux';
import DashboardHeader from './DashboardHeader';
import SalesDataTable from './SalesDataTable';

const SaleDashboard = () => {
  return (
    <div>
      <DashboardHeader />
      <SalesDataTable />
    </div>
  );
};

const mapStateToProps = (state) => ({ tickets: state.tickets });

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SaleDashboard);
